var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({attrs:{"color":_vm.color,"dark":""},domProps:{"textContent":_vm._s(_vm.title)}},'v-chip',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }